import React, { Component } from 'react'
import { Field } from 'redux-form'
import classnames from 'classnames'

export interface Props {
  name?: string // TODO-TS: I think this comes from the input
  label: string
  value: string | boolean
  checked?: any
  noPadding?: boolean
  checkmarkIcon?: boolean
}

export default class RadiobuttonGroup extends Component<Props> {
  field = (args) => {
    const { input, meta, label, noPadding, checked: defaultChecked } = args
    const { name, value, onBlur, onChange, onFocus } = input
    const { visited, touched, error, submitFailed } = meta

    let checked = input.checked
    // prettier-ignore
    if (!visited && (defaultChecked !== checked)) {
      checked = defaultChecked
    }
    const inputValue = input.value

    const radioButtons = () => {
      const handleChange = () => {
        const selected = inputValue
        onBlur(selected)
        return onChange(selected)
      }

      return (
        <div
          className={classnames({
            'form__radio-check-icon': this.props.checkmarkIcon,
          })}
        >
          <input
            type="radio"
            name={name}
            id={`radio-${name}-${label}`}
            value={value}
            checked={checked}
            onChange={handleChange}
            onFocus={onFocus}
            className={classnames('form__radio', {
              'form__control--error': submitFailed && error,
            })}
          />
          <label htmlFor={`radio-${name}-${label}`}>{label}</label>
        </div>
      )
    }

    return (
      <div
        className={classnames('form__radio-wrapper', {
          'form__radio-wrapper--no-padding': noPadding,
        })}
      >
        {radioButtons()}
        {touched && error && <p className="error text-error">{error}</p>}
      </div>
    )
  }

  render() {
    return (
      <Field<any> // TODO-TS
        {...this.props}
        type="radio"
        component={this.field}
      />
    )
  }
}
